/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * 
 * @export
 * @interface InternalApiCreateNote
 */
export interface InternalApiCreateNote {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCreateNote
     */
    alertId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateNote
     */
    content: string;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiCreateNote
     */
    alertType: InternalApiAlertType;
    /**
     * Optional draft ID to clean up after successful note creation
     * @type {number}
     * @memberof InternalApiCreateNote
     */
    draftId?: number;
}



/**
 * Check if a given object implements the InternalApiCreateNote interface.
 */
export function instanceOfInternalApiCreateNote(value: object): value is InternalApiCreateNote {
    if (!('alertId' in value) || value['alertId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    return true;
}

export function InternalApiCreateNoteFromJSON(json: any): InternalApiCreateNote {
    return InternalApiCreateNoteFromJSONTyped(json, false);
}

export function InternalApiCreateNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateNote {
    if (json == null) {
        return json;
    }
    return {
        
        'alertId': json['alertId'],
        'content': json['content'],
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'draftId': json['draftId'] == null ? undefined : json['draftId'],
    };
}

export function InternalApiCreateNoteToJSON(json: any): InternalApiCreateNote {
    return InternalApiCreateNoteToJSONTyped(json, false);
}

export function InternalApiCreateNoteToJSONTyped(value?: InternalApiCreateNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertId': value['alertId'],
        'content': value['content'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'draftId': value['draftId'],
    };
}

